<script>
    import { hangup, mute } from '../../domain/call/telephony.actions';
    import ButtonRounded from "../../common/ButtonRounded.svelte"
    import { AmplitudeLogger, CALL_STATE_CONSTANTS, EVENTS } from '../../services/utils';
    import ButtonBase from '../../common/ButtonBase.svelte';
    import { formatDuration } from 'services/utils';
    import Icon from '../../components/Icon.svelte';
    import sessionStore from '../../store/session';
    // import { createEventDispatcher } from 'svelte';
    import callStore from 'store/call';
    import pubsub from 'sweet-pubsub'
    // const dispatch = createEventDispatcher();

    let notes = $callStore.notes;
    let noteTimeOut = null;

    // let loundSpeaker = false;

    const saveNote = (notes) => {
        if ($callStore.state === CALL_STATE_CONSTANTS.INCALL || $callStore.state === CALL_STATE_CONSTANTS.OUTCALL) {
            callStore.update({
                notes
            });
        }

        pubsub.emit('call_note_save', {notes})
        notes = ''

        callStore.update({takeNote: false});
        AmplitudeLogger.log(EVENTS.NOTE_SAVED);
    };

    const handleNoteUpdate = () => {
        if (noteTimeOut) {
            clearTimeout(noteTimeOut)
        }
        noteTimeOut = setTimeout(() => {
            callStore.update({
                notes
            });
        }, 3000)
    }

    const toggleMute = () => {
        if ($callStore.microphone) {
            mute(false);
        } else {
            mute(true);
        }
    };

    const handleHangUp = () => {
        const { pending = [], id } = $sessionStore.queue || {}

        if ( id && pending.length > 0) {
            callStore.update({takeNote: false});
        }

        hangup()
    }

</script>

<div id="take-note" class="row content">
    <div
        class="ongoing-call flex items-center w-full px-4 {$callStore.state !== CALL_STATE_CONSTANTS.IDLE ? 'bg-green-600' : 'bg-red-600'}"
    >
        <div class="flex items-center justify-between">
            <!-- <span class="caller-name text-white">{ $callStore.peer }</span> -->
            <span class="text-white text-lg">{formatDuration($callStore.duration)}</span>
        </div>

        <div class="ongoing-call-ations flex py-2">
            <!-- <div class="note-icon-bg">
                <Icon
                    icon="loundspeaker"
                    color="#FFFFFF"
                    on:click={() => (loundSpeaker = !loundSpeaker)}
                />
            </div> -->
            {#if [
                CALL_STATE_CONSTANTS.INCALL, 
                CALL_STATE_CONSTANTS.OUTCALL,
                CALL_STATE_CONSTANTS.RINGING
            ].includes($callStore.state)}
                <ButtonBase
                    on:click={toggleMute}
                    disabled={[
                        CALL_STATE_CONSTANTS.INCALL, 
                        CALL_STATE_CONSTANTS.OUTCALL
                    ].includes($callStore.state)}
                >
                    <div class="bg-gray-700/50 flex justify-center items-center rounded-full h-12 w-12">
                        <Icon
                            icon={$callStore.microphone ? 'microphone-mute' : 'microphone'}
                            color="#FFFFFF"
                        />
                    </div>
                </ButtonBase>

                <ButtonBase on:click={handleHangUp}>
                    <div class="bg-gray-700/50 flex justify-center items-center rounded-full h-12 w-12">
                        <Icon icon="end-call" color="#EF3333" />
                    </div>
                </ButtonBase>
            {:else}
                <ButtonBase on:click={() => callStore.update({takeNote: false})}>
                    <div class="bg-gray-700/50 flex justify-center items-center rounded-full h-12 w-12">
                        <Icon icon="cancel" color="#EF3333" />
                    </div>
                </ButtonBase>
            {/if}
            
        </div>
    </div>
    <section>
        <div class="w-full py-2">
            <textarea 
                placeholder="Type something" 
                bind:value={notes} 
                classname="border-none border-box"
                style="height: 230px"
                on:change={handleNoteUpdate}
            />
            <div class="flex items-center">
                <div class="flex basis-4/5">
                    <ButtonRounded
                        loading={false}
                        on:click={saveNote}
                        size=8
                        title=""
                        className="call-btn-bg-color h-10 w-full flex-inline text-white px-8"
                    >Save Note</ButtonRounded>
                </div>
                <div class="flex basis-1/5 flex-row-reverse">
                    <ButtonBase on:click={() => callStore.update({takeNote: false})}>
                        <div class="bg-gray-700/50 flex justify-center items-center rounded-full h-12 w-12">
                            <Icon icon="cancel" color="#ccc" />
                        </div>
                    </ButtonBase>
                </div>
            </div>
        </div>
    </section>
</div>

<style lang="scss">
    #take-note {
        .ongoing-call {
            justify-content: space-between;
            .ongoing-call-ations {
                gap: 16px;
            }
        }
        section {
            textarea {
                color: #a7b4be;
                font-family: inherit;
                font-size: inherit;
                width: 100%;
                outline: none;
            }
        }
    }
</style>
